/**
 * Created by pajicv on 10/8/18.
 */
import React from 'react';
import { Button, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

const AddSubTaskButton = ({ onClick }) => (
    <div style={{
        display: 'flex', flexDirection: 'column', right: '16px',
        position: 'absolute'
    }}>
        <Button
            variant="fab"
            color="primary"
            aria-label="Add"
            style={{

            }}
            onClick={onClick}
        >
            <AddIcon />
        </Button>
        <Typography>Subtask</Typography>
    </div>
);

export default AddSubTaskButton;


// WEBPACK FOOTER //
// ./src/components/Tasks/AddSubTaskButton.js